var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"alt":"Vue logo","src":require("../assets/logo.png")}}),_c('p'),_c('button',{on:{"click":_vm.clickA}},[_vm._v("btn A")]),_c('p',[_vm._v("open console check tracker logs")])])}
var staticRenderFns = []

export { render, staticRenderFns }